import { render, staticRenderFns } from "./perbelanjaanPurata.vue?vue&type=template&id=229aa328&scoped=true"
import script from "./perbelanjaanPurata.vue?vue&type=script&lang=js"
export * from "./perbelanjaanPurata.vue?vue&type=script&lang=js"
import style0 from "./perbelanjaanPurata.vue?vue&type=style&index=0&id=229aa328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229aa328",
  null
  
)

export default component.exports